import React from "react";
import { BreadcrumbWrapper } from "./styles/BreadcrumbStyles";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { Link } from "react-router-dom";

const HeaderBreadcrumb = ({ ItemsName = [], GoTo = "#" }) => {
  return (
    <BreadcrumbWrapper>
      <div className="link">
        <Link to={GoTo}>
          <KeyboardBackspaceIcon />
          <span className="backText">Back</span>
        </Link>
      </div>
      <div className="breadcrumb">
        <ul>
          {ItemsName &&
            ItemsName?.map((value) => {
              return (
                <>
                  <li key={value}>
                    {value}
                    <KeyboardArrowRightIcon />
                  </li>
                </>
              );
            })}
        </ul>
      </div>
    </BreadcrumbWrapper>
  );
};

export default HeaderBreadcrumb;
